if (!customElements.get('byte-packaging-showcase')) {
  class BytePackagingShowcase extends HTMLElement {
    constructor() {
      super();

      this.boundHandleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.#bindEvents();
    }

    disconnectedCallback() {
      this.#unbindEvents();
    }

    handleClick(event) {
      const toggleButton = event.target.closest('[data-packaging-showcase-action="toggle-description"]');
      if (!toggleButton) return;

      const pointItem = toggleButton.closest('.byte-packaging-showcase__point');
      if (!pointItem) return;

      const descriptionPanel = pointItem.querySelector('[data-packaging-showcase-description]');
      if (!descriptionPanel) return;

      const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
      const nextIsExpanded = !isExpanded;

      toggleButton.setAttribute('aria-expanded', String(nextIsExpanded));
      pointItem.classList.toggle('is-expanded', nextIsExpanded);
      descriptionPanel.setAttribute('aria-hidden', String(!nextIsExpanded));
    }

    #bindEvents() {
      this.addEventListener('click', this.boundHandleClick);
    }

    #unbindEvents() {
      this.removeEventListener('click', this.boundHandleClick);
    }
  }

  customElements.define('byte-packaging-showcase', BytePackagingShowcase);
}
